/*
CSS Browser Selector v0.4.0 (Nov 02, 2010)
Rafael Lima (http://rafael.adm.br)
http://rafael.adm.br/css_browser_selector
License: http://creativecommons.org/licenses/by/2.5/
Contributors: http://rafael.adm.br/css_browser_selector#contributors
*/
function css_browser_selector(u){var ua=u.toLowerCase(),is=function(t){return ua.indexOf(t)>-1},g='gecko',w='webkit',s='safari',o='opera',m='mobile',h=document.documentElement,b=[(!(/opera|webtv/i.test(ua))&&/msie\s(\d)/.test(ua))?('ie ie'+RegExp.$1):is('firefox/2')?g+' ff2':is('firefox/3.5')?g+' ff3 ff3_5':is('firefox/3.6')?g+' ff3 ff3_6':is('firefox/3')?g+' ff3':is('gecko/')?g:is('opera')?o+(/version\/(\d+)/.test(ua)?' '+o+RegExp.$1:(/opera(\s|\/)(\d+)/.test(ua)?' '+o+RegExp.$2:'')):is('konqueror')?'konqueror':is('blackberry')?m+' blackberry':is('android')?m+' android':is('chrome')?w+' chrome':is('iron')?w+' iron':is('applewebkit/')?w+' '+s+(/version\/(\d+)/.test(ua)?' '+s+RegExp.$1:''):is('mozilla/')?g:'',is('j2me')?m+' j2me':is('iphone')?m+' iphone':is('ipod')?m+' ipod':is('ipad')?m+' ipad':is('mac')?'mac':is('darwin')?'mac':is('webtv')?'webtv':is('win')?'win'+(is('windows nt 6.0')?' vista':''):is('freebsd')?'freebsd':(is('x11')||is('linux'))?'linux':'','js']; c = b.join(' '); h.className += ' '+c; return c;}; css_browser_selector(navigator.userAgent);

/**
* hoverIntent r5 // 2007.03.27 // jQuery 1.1.2+
* <http://cherne.net/brian/resources/jquery.hoverIntent.html>
* x
* @param  f  onMouseOver function || An object with configuration options
* @param  g  onMouseOut function  || Nothing (use configuration options object)
* @author    Brian Cherne <brian@cherne.net>
*/
(function($){$.fn.hoverIntent=function(f,g){var cfg={sensitivity:7,interval:100,timeout:0};cfg=$.extend(cfg,g?{over:f,out:g}:f);var cX,cY,pX,pY;var track=function(ev){cX=ev.pageX;cY=ev.pageY;};var compare=function(ev,ob){ob.hoverIntent_t=clearTimeout(ob.hoverIntent_t);if((Math.abs(pX-cX)+Math.abs(pY-cY))<cfg.sensitivity){$(ob).unbind("mousemove",track);ob.hoverIntent_s=1;return cfg.over.apply(ob,[ev]);}else{pX=cX;pY=cY;ob.hoverIntent_t=setTimeout(function(){compare(ev,ob);},cfg.interval);}};var delay=function(ev,ob){ob.hoverIntent_t=clearTimeout(ob.hoverIntent_t);ob.hoverIntent_s=0;return cfg.out.apply(ob,[ev]);};var handleHover=function(e){var p=(e.type=="mouseover"?e.fromElement:e.toElement)||e.relatedTarget;while(p&&p!=this){try{p=p.parentNode;}catch(e){p=this;}}if(p==this){return false;}var ev=jQuery.extend({},e);var ob=this;if(ob.hoverIntent_t){ob.hoverIntent_t=clearTimeout(ob.hoverIntent_t);}if(e.type=="mouseover"){pX=ev.pageX;pY=ev.pageY;$(ob).bind("mousemove",track);if(ob.hoverIntent_s!=1){ob.hoverIntent_t=setTimeout(function(){compare(ev,ob);},cfg.interval);}}else{$(ob).unbind("mousemove",track);if(ob.hoverIntent_s==1){ob.hoverIntent_t=setTimeout(function(){delay(ev,ob);},cfg.timeout);}}};return this.mouseover(handleHover).mouseout(handleHover);};})(jQuery);
(function($){$.toJSON=function(o)
{if(typeof(JSON)=='object'&&JSON.stringify)
return JSON.stringify(o);var type=typeof(o);if(o===null)
return"null";if(type=="undefined")
return undefined;if(type=="number"||type=="boolean")
return o+"";if(type=="string")
return $.quoteString(o);if(type=='object')
{if(typeof o.toJSON=="function")
return $.toJSON(o.toJSON());if(o.constructor===Date)
{var month=o.getUTCMonth()+1;if(month<10)month='0'+month;var day=o.getUTCDate();if(day<10)day='0'+day;var year=o.getUTCFullYear();var hours=o.getUTCHours();if(hours<10)hours='0'+hours;var minutes=o.getUTCMinutes();if(minutes<10)minutes='0'+minutes;var seconds=o.getUTCSeconds();if(seconds<10)seconds='0'+seconds;var milli=o.getUTCMilliseconds();if(milli<100)milli='0'+milli;if(milli<10)milli='0'+milli;return'"'+year+'-'+month+'-'+day+'T'+
hours+':'+minutes+':'+seconds+'.'+milli+'Z"';}
if(o.constructor===Array)
{var ret=[];for(var i=0;i<o.length;i++)
ret.push($.toJSON(o[i])||"null");return"["+ret.join(",")+"]";}
var pairs=[];for(var k in o){var name;var type=typeof k;if(type=="number")
name='"'+k+'"';else if(type=="string")
name=$.quoteString(k);else
continue;if(typeof o[k]=="function")
continue;var val=$.toJSON(o[k]);pairs.push(name+":"+val);}
return"{"+pairs.join(", ")+"}";}};$.evalJSON=function(src)
{if(typeof(JSON)=='object'&&JSON.parse)
return JSON.parse(src);return eval("("+src+")");};$.secureEvalJSON=function(src)
{if(typeof(JSON)=='object'&&JSON.parse)
return JSON.parse(src);var filtered=src;filtered=filtered.replace(/\\["\\\/bfnrtu]/g,'@');filtered=filtered.replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,']');filtered=filtered.replace(/(?:^|:|,)(?:\s*\[)+/g,'');if(/^[\],:{}\s]*$/.test(filtered))
return eval("("+src+")");else
throw new SyntaxError("Error parsing JSON, source is not valid.");};$.quoteString=function(string)
{if(string.match(_escapeable))
{return'"'+string.replace(_escapeable,function(a)
{var c=_meta[a];if(typeof c==='string')return c;c=a.charCodeAt();return'\\u00'+Math.floor(c/16).toString(16)+(c%16).toString(16);})+'"';}
return'"'+string+'"';};var _escapeable=/["\\\x00-\x1f\x7f-\x9f]/g;var _meta={'\b':'\\b','\t':'\\t','\n':'\\n','\f':'\\f','\r':'\\r','"':'\\"','\\':'\\\\'};})(jQuery);

$(document).ready( function() {
jQuery('a[href^="http"]').not('a[href^="'+$(location).attr('hostname')+'"]').attr('target', '_blank');
});

//Old JM JS
(function(){
  
  //Sold Out Stock
  

  //Show and hide the checkout link
  $('a#checkout-link').css('opacity','0');
  $('#shopping-cart').hover(function(){
  $('a#checkout-link').animate({
  opacity: 1
  }, 200);
  }, function() {
  $('a#checkout-link').animate({
  opacity: 0
  }, 200);
  });

	$('#qty-holder a').click(function(ev){
		var inElm = $(this).closest('#qty-holder').find('.qty');
		if(ev.target.className === "more"){
			increaseQty(1, inElm);
		} else {
			decreaseQty(1, inElm);
		}
	})

	var increaseQty = function(count, inElm){
		var currentVal = inElm.val();
      	var newVal = parseInt(currentVal)+1;
      	inElm.val(newVal);
	}
    
    var decreaseQty = function(count, inElm){
    	var currentVal = inElm.val();
      	var newVal = parseInt(currentVal)-1;
      	inElm.val(newVal);
    }
    
    
    $('.hproduct').each(function(){
    	$(this).children('.info-holder').hide();
    	
      	$(this).hoverIntent(function(){
    		$(this).children('.info-holder').fadeIn(200);
    	}, function(){
    		$(this).children('.info-holder').fadeOut(200);
    	});
    });
  
})();

$('#qty-holder .btn-basic').on('click', function(){
  $('#cartform').submit();
})

$('.first-col').mouseenter(function(){
  if( $('.family-product').length > 0 ){
    $('.first-col p').css('font-weight', 'normal');
  	var val = $(this).find('p').css('font-weight','bold').html().toLowerCase();
    var newVal = val.replace(/\s+/g, '');
  	var imgs = $('.right img').hide();
  	var showImg = $('[alt='+ newVal +']').show();
  }
});

$('.product-header').mouseenter(function(){
  if($('.family-product').length > 0){
  	$('.right img').hide();
  	var showImg = $('[alt="default"]').show();
  }
})


$('input#email-signup').focus(function() {
var theValue = $(this).val();
if(theValue == 'Enter Email Address') {
$(this).val('');
}
});
$('input#email-signup').blur(function() {
var theValue = $(this).val();
if(theValue == '') {
$(this).val('Enter Email Address');
}
});

if( $('.alt-title').length > 0 ){
  $('.product-title').text( $('.alt-title').text() ) 
  $('.alt-title').hide();
}

$.fn.exists = function () {
    return this.length !== 0;
}

$(function(){
  if( $('.desc p').length > 0 ){
  	$('.desc p').succinct({
        size: 150
    });
  }
});

$(document).ready(function(){
  jQuery.ajaxSetup({cache: false});
  
  $('body').css('zoom', '0');
  
  
    
    if(window.location.search === '?related'){
      	var collection = $('body').data('collection');
    	$('.dynamic-back').find('a').attr('href', 'http://www.jaspermorrisonshop.com' + collection);
    } else {
    	$('.dynamic-back').find('a').attr('href', document.referrer);	
    }
  
  if( $('#back-to-categories').exists() ){
  	$('#back-to-categories').find('a').attr('href', '/');
  }
  
  if( $('#related').exists() ){
    var links = $('#related a');
  	$.each(links, function(){
  		this.href = this.href+'?related'
  	});
  }
  
  if( $('#pagination .next').exists() ){
  	$('#pagination').find('.next > a').text('Next')
  }
  
  if( $('#pagination .prev').exists() ){
  	$('#pagination').find('.prev > a').text('Previous')
  }
  
})
